import axios from "axios";
const API_URL = 'http://localhost:8080/api'

export const SellToBid = async (BidID) => {
    
  try {
      const { data } = await axios.post(
          `${API_URL}/bid/accept`,
          {
              BidID:BidID
          },
          { withCredentials: true }
      );
      if (data) {
          if (data.errors) {
            
          } else {
            
             return data
          }
      }
  } catch (ex) {
      
  }
};